export default {
    AGENDADO: 1,
    CANCELADO: 2,
    TRANSPORTADO: 3,
    FALTOU: 4
}